import { TODAY, YESTERDAY, TOMORROW } from '../types/General/dayTypeAction'

const initialState = {
    dayType: "today",
    dayPosition: 0
}

const dayTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case TODAY:
            return {
                ...state,
                dayType: "today",
                dayPosition: 0
            }
            break;
        case YESTERDAY:
            return {
                ...state,
                dayType: "yesterday",
                dayPosition: state.dayPosition - 1
            }
            break;
        case TOMORROW:
            return {
                ...state,
                dayType: "tomorrow",
                dayPosition: state.dayPosition + 1
            }
            break;
        default: return state
    }
}

export default dayTypeReducer;